export default __webpack_public_path__ + "static/media/infoToolTip.659aa262.svg";